var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ButtonDelete',{attrs:{"aria-label":"Open Deletion Modal"},on:{"click":_vm.handleOpenDeleteModal}}),_c('DeleteKeyModal',{attrs:{"bodyTextEmphasized":_vm.bodyTextEmphasized,"headerText":_vm.headerText,"isOpen":_vm.isModalOpen},on:{"cancel":_vm.handleCloseDeleteModal,"confirm":_vm.handleDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }